'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

var b=({children:a,showMobileMenu:s,className:e})=>{let l=s?"mobile-menu-open":"",i=e||"",t=react.Children.map(a.props.children,(m,p)=>jsxRuntime.jsx("li",{className:"navbar-list-item",children:m},p));return jsxRuntime.jsx("ul",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-navbar-menu ${l} ${i}`),children:t})},c=b;

exports.a = c;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-J76562Y6.js.map